<div *ngIf="productList" class="product__carouselSection">
  <div class="innerContainer">
    <h2 class="vc-title-m product__carouselSection__title">{{ title }}</h2>
    <vc-carroussel-products
      [items]="productList"
      [seoContext]="seoContext"
      (carouselProductClick)="onCarouselProductClick($event)"
    ></vc-carroussel-products>
  </div>
</div>
